
export default function AdvertisingDisclosure() {
    return (
        <main className="min-h-screen bg-pink-50">
            <section className="max-w-3xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                <h1 className="text-3xl font-bold text-slate-900 mb-4">
                    Advertising & Affiliate Disclosure
                </h1>

                <div className="space-y-6 text-slate-800 leading-relaxed">
                    <p>
                        UnicorNation displays images, banners, and links from external
                        businesses on the website. Some of these placements may be:
                    </p>
                    <ul className="list-disc list-inside space-y-1">
                        <li>Paid promotions</li>
                        <li>Sponsored content</li>
                        <li>Affiliate links</li>
                    </ul>

                    <p>
                        This means that if you click on certain links and make a purchase, we
                        may receive a small commission or fee. This helps support the
                        platform and allows us to keep curating events and resources for the
                        community.
                    </p>

                    <p>
                        We aim to partner with businesses and services that are relevant to
                        our audience and values, but we do not control the operations,
                        quality, or policies of these third parties.
                    </p>

                    <p>
                        All purchases, bookings, or other transactions you make after leaving
                        our site are solely between you and the external provider. Please
                        review their terms and policies before proceeding with any
                        transaction.
                    </p>

                    <p>
                        If you have any questions about our advertising or affiliate
                        relationships, please contact us at:
                    </p>
                    <p className="font-medium">
                        contact@unicornation.com.au
                    </p>
                </div>
            </section>
        </main>
    );
}
